import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import generateId from './generateId';
import { updateHashProps, rewriteUserId } from '../general';
import { addDatasToSave, loadDbModel } from './workBackendSlice';
import { saveAllData, saveData, deleteData, SignUpPayload } from './dataBackend';

export type NoteDb = {
  userId: string;
  referenceId: string;
  content: string;
}
const initial: NoteDb = {
  userId: '',
  referenceId: '',
  content: ''
};

export type NoteDbHashType = {
  [key in string]: NoteDb;
}

export type NoteAddPayload = {
  id?: string;
} & NoteDb;
export type NoteUpdatePayload = {
  id: string;
} & { [P in keyof NoteDb]?: NoteDb[P] };

export type NoteDbState = {
  notes: NoteDbHashType;
}

export const  generateNoteId = (): string =>  generateId('n');
let initialState: NoteDbState = { notes: {} };
const key = 'notes';

const noteDbSlice = createSlice({
  name: 'noteDb',
  initialState,
  reducers: {
    initializeNotes(state: NoteDbState) {
      state.notes = {};
    },
    addNote(state: NoteDbState, action: PayloadAction<NoteAddPayload>) {
      let { id, ...obj } = action.payload;
      if (!id) id = generateNoteId();
      state.notes[id] = obj;
      saveData(key, id, obj);
    },
    updateNote(state: NoteDbState, action: PayloadAction<NoteUpdatePayload>) {
      const { id, ...obj } = action.payload;
      if (state.notes[id] === undefined) {
        console.log(`*** Note not found: ${id}`);
      } else {
        const newData = { ...state.notes[id], ...obj };
        state.notes[id] = newData;
        saveData(key, id, newData);
      }
    },
    deleteNote(state: NoteDbState, action: PayloadAction<NoteUpdatePayload>) {
      const id = action.payload.id;
      delete state.notes[id];
      deleteData(key, id);
    },
    saveNotes(state: NoteDbState) {
      saveAllData(key, state.notes);
    },
    signUpNotes(state: NoteDbState, action: PayloadAction<SignUpPayload>) {
      const values = rewriteUserId(state.notes, action.payload);
      addDatasToSave(key, values);
    }
  },
  extraReducers: (builder) => {
    builder.addCase(loadDbModel(key).fulfilled, (state: NoteDbState, action) => {
      const values = action.payload;
      const [changed, updatedValues] = updateHashProps(initial, values);
      state.notes = updatedValues;
      if (changed) saveAllData(key, state.notes);
    })
  }
})

export const { initializeNotes, addNote, updateNote, deleteNote, saveNotes, signUpNotes } = noteDbSlice.actions;
export default noteDbSlice.reducer;
